/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Light_ModeInputs */

const en_mobile_light_mode = /** @type {(inputs: Mobile_Light_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light Mode`)
};

const es_mobile_light_mode = /** @type {(inputs: Mobile_Light_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo claro`)
};

/**
* | output |
* | --- |
* | "Light Mode" |
*
* @param {Mobile_Light_ModeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_light_mode = /** @type {((inputs?: Mobile_Light_ModeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Light_ModeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_light_mode(inputs)
	return en_mobile_light_mode(inputs)
});